<template>
  <RemainingPicks v-bind="{ remaining }">
    <template #done>
      {{ $t('highfrequencygame.spots.remaining.empty') }}
    </template>

    <i18n-t keypath="highfrequencygame.spots.remaining" :n="2" scope="global">
      <template #count>
        <RemainingPicksBubble v-bind="{ remaining }" />
      </template>
    </i18n-t>
  </RemainingPicks>
</template>

<script lang="ts" setup>
type Props = { remaining: number }

defineProps<Props>()
</script>
